import React, {
    useCallback, useState, useMemo, useEffect
} from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import appConfig from 'app-config';
import _ from 'lodash';
import classNames from 'classnames';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-unresolved
import { MLFaqService } from 'ml-portals-services-react';
import FaqSectionComponent from '../../components/FaqSectionComponent/FaqSectionComponent';
import metadata from './FaqPage.metadata.json5';
import styles from './FaqPage.module.scss';

const isQnB = appConfig.portalCode === 'QB';

function FaqSideBar(props) {

    const { value, enabled } = props;
    const { id, title } = value;

    const sidebarLinkStyle = classNames(styles.wizardLi, {
        [styles.wizardLiDisabled]: !enabled
    });

    return (
        <li key={id} className={sidebarLinkStyle}>
            <Link to={`/faq#${id}`}>{title}</Link>
        </li>
    );
}

function checkSafeMatching(phrase = '', query = '') {
    const htmlStrippedPhrase = _.unescape(phrase.replace(/<[^<>]+>/gi, ''));
    return htmlStrippedPhrase.toLocaleLowerCase().includes(query.toLowerCase());
}

const searchTopic = (topic, query) => {
    const questionMatching = checkSafeMatching(topic.question, query);
    const answerMatching = checkSafeMatching(topic.long, query);
    const linkMatching = topic.link && topic.link.name ? checkSafeMatching(topic.link.name, query) : false;

    return questionMatching || answerMatching || linkMatching;
}; 

const filterTopics = (topics, query) => {
    return topics.filter((topic) => searchTopic(topic, query));
};

const getFilteredSections = (sections, query) => {
    return sections
        .map((section) => {
            if (isQnB && section.id === "ml-faq-contact-us") {
                const updatedTopics = section.topics.map((topic) =>
                    topic.id === "Faq-2-contact-us"
                        ? {
                            ...topic, long: "You can contact us by phone. Contact Sales for help with your new policy quote or Service for help with your policy.<br><br>" +
                                "<li>For Sales Team: Monday – Friday 8:00 am – 10:30 pm ET;Saturday 9:00 am – 5:30 pm ET </li>" +
                                "<li>For Service Team: Monday - Friday 8:00 am - 11:00 pm ET; Saturday 9:00 am - 5:00 pm ET </li> <br>" +
                  
                                "Call Sales/Service representatives:<br>" +
                                "<li>For help on new policy quotes, call Sales 1-844-451-1832,</li>" +
                                "<li>For help with your policy, call Service 1-800-422-4272,</li>"
                        }
                        : topic
                );
 
                return { ...section, topics: filterTopics(updatedTopics, query) };
            }
 
            return { ...section, topics: filterTopics(section.topics, query) };
        })
        .filter((section) => !_.isEmpty(section.topics));
};

function FaqPage() {
    const [formData, setFormData] = useState({ searchTopic: '' });

    const filteredSections = useMemo(() => {
        return getFilteredSections(MLFaqService.getAllSections(), formData.searchTopic);
    }, [formData.searchTopic]);

    const readValue = useCallback(
        (id, path = '') => {
            if (id === 'searchTopicField') {
                return _.get(formData, path);
            }

            if (path && path.includes('filteredSections')) {
                const sectionPath = path.replace('filteredSections', 'sections');
                const newFaqObject = { sections: filteredSections };
                return _.get(newFaqObject, sectionPath);
            }

            return _.get(MLFaqService.getFaqJson(), path);
        },
        [filteredSections, formData]
    );

    const writeValue = useCallback(
        (value, path) => {
            const formDataClone = _.cloneDeep(formData);
            _.set(formDataClone, path, value);
            setFormData(formDataClone);
        },
        [formData, setFormData]
    );

    const generatedOverrides = useCallback(() => {
        const searchTopicText = _.get(formData, 'searchTopic');

        const sectionOverrides = MLFaqService.getAllSections().map((section, index) => {
            const linkEnabled = filteredSections.some((item) => item.id === section.id);

            return {
                [`faqSectionContainer${index}`]: {
                    searchText: searchTopicText
                },
                [`faqSidebarSectionPageTitle${index}`]: { enabled: linkEnabled }
            };
        });

        return Object.assign({}, ...sectionOverrides);
    }, [filteredSections, formData]);

    const overrideProps = {
        '@field': {
            onValueChange: writeValue
        },
        ...generatedOverrides()
    };
    
    useEffect(() => {
        if(window.location.hash && window.location.hash.length > 0) {
            let currentHash = window.location.hash;

            if (currentHash.endsWith('/')) {
                currentHash = currentHash.slice(0, -1);
            }
            
            window.location.hash = currentHash;
        }
    });

    useEffect(() => {    
    if (typeof Invoca !== 'undefined') {      
        Invoca.PNAPI.run();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    const resolvers = {
        resolveValue: readValue,
        resolveComponentMap: {
            faqsidebar: FaqSideBar,
            faqsectioncomponent: FaqSectionComponent
        },
        resolveClassNameMap: styles
    };

    return (
        <div><MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            {...resolvers} /></div>
    );
}

FaqSideBar.propTypes = {
    value: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
    }).isRequired,
    enabled: PropTypes.bool.isRequired
};

export default FaqPage;
